export default {
  en: {
    yes: 'Yes',
    no: 'No',
    unanswered: 'Unanswered',
    notApplicable: 'Not applicable',
    invalid: 'Invalid',
    notRequired: 'Not required',
    requireNo: 'Require no',
    outOfScope: 'Out of scope',
    answer: 'Answer',
    answered: 'Answered',
    youAnswered: 'You answered',
    editAnswer: 'Edit answer',
    lastModified: 'Last modified {0}',
    dateFormat: 'YYYY/MM/DD',
  },
};
